import { cn } from "../../lib/cn";

/**
 * La marca de PrintFlow. **Copiada tal cual de `imprenta`** (ADR 0027).
 *
 * No se rehizo ni se simplificó: es diseño ya hecho, y reusarlo es exactamente
 * lo que el ADR pide. Los dos degradados y los ids (`pfGradient`, `pfGlow`) son
 * los de allá.
 *
 * **Los ids son globales en el documento.** Si algún día se renderizan dos
 * marcas a la vez con distinto color, hay que sufijarlos — hoy hay una sola por
 * pantalla y no hace falta.
 */
export function PrintFlowMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      className={cn("h-10 w-10", className)}
    >
      <defs>
        <linearGradient
          id="pfGradient"
          x1="10"
          y1="8"
          x2="52"
          y2="56"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#38bdf8" />
          <stop offset="1" stopColor="#0ea5e9" />
        </linearGradient>
        <linearGradient id="pfGlow" x1="20" y1="16" x2="46" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#e0f2fe" />
          <stop offset="1" stopColor="#bae6fd" />
        </linearGradient>
      </defs>
      <rect x="8" y="10" width="48" height="44" rx="12" fill="url(#pfGradient)" opacity="0.18" />
      <path
        fill="url(#pfGradient)"
        d="M18 15c0-3.866 3.134-7 7-7h18c9.389 0 17 7.611 17 17S52.389 42 43 42H28v7c0 3.866-3.134 7-7 7h-5V15Z"
      />
      <path
        fill="url(#pfGlow)"
        d="M24 19a3 3 0 0 1 3-3h15c6.075 0 11 4.925 11 11S48.075 38 42 38H29v3a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V19Z"
      />
      <path
        d="M24 32h16.5l-4.2-4.2 2.3-2.3 7.7 7.7-7.7 7.7-2.3-2.3 4.2-4.2H24a5 5 0 0 0 0 10h7.5"
        fill="none"
        stroke="#0c4a6e"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="21" r="2" fill="#0c4a6e" />
    </svg>
  );
}
